const TIMEOUT_MS = 4000;

/** No backend reachability endpoint — no-cors fetch only tells us if the request completed, which is enough. */
export const isEwrUrlReachable = async (url: string): Promise<boolean> => {
	// WHY: AbortSignal.timeout() isn't available in every runtime this code may run in.
	const controller = new AbortController();
	const timeoutId = setTimeout(() => controller.abort(), TIMEOUT_MS);

	try {
		await fetch(url, {
			mode: "no-cors",
			signal: controller.signal,
		});
		return true;
	} catch {
		return false;
	} finally {
		clearTimeout(timeoutId);
	}
};
